import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBaiduComponent } from './simple-icons-baidu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBaiduComponent ],
    exports:      [ SimpleIconsBaiduComponent ],
    bootstrap:    []
})
export class SimpleIconsBaiduModule {}
